import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Config, DriveStep, Popover } from 'driver.js';

import { AbstractGuideService } from '../../../shared-components/guide/core/services/abstract-guide.service';
import { GuideDriverAdapterService } from '../../../shared-components/guide/core/services/guide-driver-adapter.service';

@Injectable()
export class AutoLotsFilterGuideService extends AbstractGuideService {
  constructor(
    guideDriverAdapterService: GuideDriverAdapterService,
    translateService: TranslateService,
  ) {
    super(guideDriverAdapterService, translateService);
  }

  start(): void {
    const config: Config = {
      prevBtnText: this.translate('DRIVER_CONFIG.PREV_BTN'),
      nextBtnText: this.translate('DRIVER_CONFIG.NEXT_BTN'),
      doneBtnText: this.translate('DRIVER_CONFIG.DONE_BTN'),
      steps: this.buildSteps(),
    };

    this.startGuide(config);
  }

  forceClose(): void {
    this.destroyGuideSafely();
  }

  private buildSteps(): DriveStep[] {
    return [
      this.buildStep('auction-days', 'AUTO_FILTER_GUIDE.0.TITLE', 'AUTO_FILTER_GUIDE.0.TEXT', {
        showButtons: ['next'],
      }),
      this.buildStep('company', 'AUTO_FILTER_GUIDE.1.TITLE', 'AUTO_FILTER_GUIDE.1.TEXT'),
      this.buildStep('model', 'AUTO_FILTER_GUIDE.2.TITLE', 'AUTO_FILTER_GUIDE.2.TEXT'),
      this.buildStep('frame', 'AUTO_FILTER_GUIDE.3.TITLE', 'AUTO_FILTER_GUIDE.3.TEXT'),
      this.buildStep('auction', 'AUTO_FILTER_GUIDE.4.TITLE', 'AUTO_FILTER_GUIDE.4.TEXT'),
      this.buildStep('score', 'AUTO_FILTER_GUIDE.5.TITLE', 'AUTO_FILTER_GUIDE.5.TEXT'),
      this.buildStep('color-transmission', 'AUTO_FILTER_GUIDE.6.TITLE', 'AUTO_FILTER_GUIDE.6.TEXT'),
      this.buildStep('technical-ranges', 'AUTO_FILTER_GUIDE.7.TITLE', 'AUTO_FILTER_GUIDE.7.TEXT'),
      this.buildStep('lot-number', 'AUTO_FILTER_GUIDE.8.TITLE', 'AUTO_FILTER_GUIDE.8.TEXT'),
      this.buildStep('truck', 'AUTO_FILTER_GUIDE.9.TITLE', 'AUTO_FILTER_GUIDE.9.TEXT'),
      this.buildStep('model-grade', 'AUTO_FILTER_GUIDE.10.TITLE', 'AUTO_FILTER_GUIDE.10.TEXT'),
      this.buildStep('drive', 'AUTO_FILTER_GUIDE.11.TITLE', 'AUTO_FILTER_GUIDE.11.TEXT'),
      this.buildStep('production-date', 'AUTO_FILTER_GUIDE.12.TITLE', 'AUTO_FILTER_GUIDE.12.TEXT'),
      this.buildStep(
        'auction-not-started',
        'AUTO_FILTER_GUIDE.13.TITLE',
        'AUTO_FILTER_GUIDE.13.TEXT',
      ),
      this.buildStep('presets', 'AUTO_FILTER_GUIDE.14.TITLE', 'AUTO_FILTER_GUIDE.14.TEXT'),
      this.buildStep('actions', 'AUTO_FILTER_GUIDE.15.TITLE', 'AUTO_FILTER_GUIDE.15.TEXT'),
      this.buildStep('extended-search', 'AUTO_FILTER_GUIDE.16.TITLE', 'AUTO_FILTER_GUIDE.16.TEXT'),
    ];
  }

  private buildStep(
    anchor: string,
    titleKey: string,
    descriptionKey: string,
    overrides?: Partial<Popover>,
  ): DriveStep {
    return {
      element: this.buildAnchorSelector(anchor),
      popover: this.buildPopover({
        titleKey,
        descriptionKey,
        overrides,
      }),
    };
  }
}
